import JSEncrypt from 'jsencrypt'

const pubKey = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvRoXoL/mzCoIGhWCF2zPZ5n/5RWroMXcQUlYOndxUTmghb2FGohcrsugxh8p1ia41luZhLZujJF2ych8a5/tPZH4bNvGwSSi451toMkNRDthXntPnX3APUEhjiJsBbMMaVMb5v0g5rSsW5Y09YLWzLW2FW7+BB3S7fwpB4OoF9PfQ8XVEJEero0aKjw5S04R6Ed+n58U0iJBeoUawF4PYYcgGsRxDEosfcfEBZ8xXzL02zB4Yu/TjQSjf8F8h9fefiNW0xm/c/eYqW68fOvRcxN5LtUflXlznAMPnGYIG3K+BwOldQgpSkdFfV/hqtXCYbLz+JKGjz4xlHiRKJGxEwIDAQAB-----END PUBLIC KEY-----'

const RSA = {
  encrypt (str) {
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(pubKey)
    return encrypt.encrypt(str)
  }
}
export default RSA
